export default __webpack_public_path__ + "img/cef3194ba55fd000578e129652941374.png";